import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/a11.png";
import emotion from "../../Assets/Projects/a6.png";
import editor from "../../Assets/Projects/a3.png";
import chatify from "../../Assets/Projects/a10.png";
import suicide from "../../Assets/Projects/a5.png";
import bitsOfCode from "../../Assets/Projects/a2.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Meus Principais <strong className="purple">Projetos </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="G&N International Business"
              description="Desenvolvido do zero um site de apresentação da empresa com opções em Inglês e 
              Espanhol, também fui responsável por hospedar no domínio solicitado e cuidar da 
              segurança."
              ghLink="https://github.com/luizassano/gninternational-site"
              demoLink="https://www.gnbusiness.com.br/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Framboesa Flix"
              description="Projeto feito em React.js, consumindo a API do TMDB, onde é possível buscar qualquer filme e série, além de obter diversas informações sobre título escolhido."
              ghLink="https://github.com/luizassano/react-framboesaflix2.0"
              demoLink="https://framboesaflix.vercel.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="OrganizaAÍ"
              description="Projeto feito em equipe, com uma solução inovadora onde a organização de eventos é mais fácil e intuitiva, oferecendo uma plataforma amigável e acessível."
              ghLink="https://github.com/maiceljunior/capstone-organiza-ai-m3"
              demoLink="https://capstone-organiza-ai-m3.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Nu Kenzie"
              description="Desenvolvido utilizando Typescript com a biblioteca React.js , o portal oferece aos usuários o controle financeiro completo, permitindo o registro de despesas e entradas de valores. O saldo é calculado dinamicamente, proporcionando aos usuários informações precisas e atualizadas sobre sua situação financeira"
              ghLink="https://github.com/luizassano/react-nukenzie-luizassano"
              demoLink="https://nukenzie-luizassano.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Kenzie Burguer"
              description="Aplicação que simula uma loja de fast-food, com a possibilidade de adicionar itens ao carrinho e realizar o cálculo dos preços de forma dinâmica. Para isso, utilizei uma API da Kenzie que simula uma Hamburgueria com produtos.
              O projeto foi cuidadosamente planejado e implementado para oferecer uma experiência de usuário intuitiva e agradável."
              ghLink="https://github.com/luizassano/REACT-Hamburgueria-Kenzie-luizassano"
              demoLink="https://entrega-seven.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Buscador CEP"
              description="O projeto foi desenvolvido em React.js com a finalidade de buscar o CEP informado pelo usuário no campo de busca e exibir as informações na tela. Trata-se de um dos meus primeiros projetos utilizando essa tecnologia, com esse projeto, aprimorei minhas habilidades em React.js e buscando sempre a melhor navegação pelo usuário "
              ghLink="https://github.com/luizassano/REACT-Buscador-de-CEP"
              demoLink="https://cep-busca.vercel.app/" 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
